var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-block",class:_vm.lang},[_vm._t("default",[_c('code',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }